

/*******************************************************************************
 * Initial state
 */
const initialState = {
    errorList: [],
    nextErrorId: 0
};


/*******************************************************************************
 * Action types
 */
export const ERROR_ADD = 'ERROR_ADD';
export const ERROR_DISMISS = 'ERROR_DISMISS';
export const ERROR_DISMISS_ALL = 'ERROR_DISMISS_ALL';
export const ERROR_DISMISS_BY_TYPE = 'ERROR_DISMISS_BY_TYPE';


/*******************************************************************************
 * Reducer
 */
export default function errorData( state = initialState, action ) {
    switch ( action.type ) {
        case ERROR_ADD:
            return {
                ...state,
                nextErrorId: state.nextErrorId + 1,
                errorList: [ ...state.errorList, Object.assign( action.error, { errorType: action.errorType, errorId: state.nextErrorId + 1 } ) ]
            };

        case ERROR_DISMISS:
            return {
                ...state,
                errorList: state.errorList.filter( error => {
                    return error.errorId !== action.errorId;
                } )
            };

        case ERROR_DISMISS_ALL:
            return {
                ...state,
                errorList: []
            };

        case ERROR_DISMISS_BY_TYPE:
            return {
                ...state,
                errorList: state.errorList.filter( error => error.errorType !== action.errorType )
            };
        default:
            return state;
    }
}


/*******************************************************************************
 * Action creators
 */
export function addError( error, errorType ) {
    return ( dispatch ) => {
        dispatch( {
            type: ERROR_ADD,
            error,
            errorType
        } );
    };
}

export function dismissError ( errorOrErrorId ) {
    return {
        type: ERROR_DISMISS,
        errorId: typeof ( errorOrErrorId ) === 'number' ? errorOrErrorId : errorOrErrorId.errorId
    };
}

export function dismissAllErrors () {
    return {
        type: ERROR_DISMISS_ALL
    };
}

export function dismissErrorsByType( errorType ) {
    return {
        type: ERROR_DISMISS_BY_TYPE,
        errorType
    };
}
